import type { BookEventPayload } from './bookEvent.types';

export const EVENT_TYPES = {
  CLASS: 'class',
  COURSE: 'course',
  TIMESLOT: 'timeslot',
  EVENT: 'event',
} as const;

type ServiceDescriptor = {
  id: string | null;
  type: string | null;
};

const TIMESLOT_SERVICE_TYPES: Record<string, string> = {
  facilities: 'facilities',
  users: 'trainers',
  appointments: 'appointments',
};

function getTimeslotService(event: BookEventPayload): ServiceDescriptor {
  const model = event.timeslotToBook?.model || event.model || '';
  const type = TIMESLOT_SERVICE_TYPES[model] || null;
  return { id: type ? event._id || null : null, type };
}

function getServiceDescriptor(event: BookEventPayload): ServiceDescriptor {
  const resolvers: Partial<
    Record<NonNullable<BookEventPayload['type']>, () => ServiceDescriptor>
  > = {
    [EVENT_TYPES.COURSE]: () => ({ id: event._id || null, type: 'courses' }),
    [EVENT_TYPES.CLASS]: () => ({ id: event.program_id || null, type: 'classes' }),
    [EVENT_TYPES.TIMESLOT]: () => getTimeslotService(event),
  };
  return resolvers[event.type || EVENT_TYPES.EVENT]?.() || { id: null, type: null };
}

export function getServiceID(event: BookEventPayload): string | null {
  return getServiceDescriptor(event).id;
}

export function getServiceType(event: BookEventPayload): string | null {
  return getServiceDescriptor(event).type;
}
